export const getTextNodes = (body: HTMLElement) => {
  const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  do {
    if (walker.currentNode.nodeType === Node.TEXT_NODE) textNodes.push(walker.currentNode);
  } while (walker.nextNode());
  return textNodes;
};
